import { Speaker } from '../types';
import { apiClient } from './api';

interface CreateSpeakerRequest {
  originalLabel: string;
  name?: string;
  role?: string;
}

interface UpdateSpeakerRequest {
  name: string;
  role?: string;
}

interface SpeakersResponse {
  data: Speaker[];
}

interface SpeakerResponse {
  data: Speaker;
}

class SpeakersService {
  private baseUrl = '/transcripts';

  async getSpeakers(audioFileId: string): Promise<Speaker[]> {
    const response = await apiClient.get<SpeakersResponse>(
      `${this.baseUrl}/${audioFileId}/speakers`
    );
    return response.data.data;
  }

  async createSpeaker(
    audioFileId: string,
    data?: CreateSpeakerRequest
  ): Promise<Speaker> {
    const response = await apiClient.post<SpeakerResponse>(
      `${this.baseUrl}/${audioFileId}/speakers`,
      data || {}
    );
    return response.data.data;
  }

  async updateSpeaker(
    audioFileId: string,
    speakerId: string,
    data: UpdateSpeakerRequest
  ): Promise<Speaker> {
    const response = await apiClient.put<SpeakerResponse>(
      `${this.baseUrl}/${audioFileId}/speakers/${speakerId}`,
      {
        speaker: data,
      }
    );
    return response.data.data;
  }

  async deleteSpeaker(audioFileId: string, speakerId: string): Promise<void> {
    await apiClient.delete(
      `${this.baseUrl}/${audioFileId}/speakers/${speakerId}`
    );
  }
}

export const speakersService = new SpeakersService();
